export const getPageTitle = (...labels: (string | null | undefined)[]) => {
  return ['Quill.org', ...labels.filter(Boolean)].join(' | ')
}
